import { render, staticRenderFns } from "./DataRooms.vue?vue&type=template&id=49f1f44d&scoped=true&"
import script from "./DataRooms.vue?vue&type=script&lang=js&"
export * from "./DataRooms.vue?vue&type=script&lang=js&"
import style0 from "./DataRooms.vue?vue&type=style&index=0&id=49f1f44d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49f1f44d",
  null
  
)

export default component.exports